import { WizardLauncherService } from '../../wizard.launcher.service';
import { UserService, ValuesExchangeProvider } from '@nrwl/common-lib';
import { BaseWizardService } from '../../services/base.wizard.service';
import {
  Component,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  EventEmitter,
  ViewContainerRef,
  ComponentFactoryResolver
} from '@angular/core';
import { get, merge } from 'lodash';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { IWizardEntry } from '../../wizard.entry';
import { WizardComponent } from '../../wizard.component';
import { ThresholdSiteSelectionComponent } from './threshold.site.selection.page/threshold.site.selection.page.component';
import { ThresholdWizardService } from '../../services/threshold/threshold.wizard.service';
import { ThresholdSettingsComponent } from './threshold.settings.page/threshold.settings.page.component';
import { ThresholdApplicationSelectionComponent } from './threshold.application.selection.page/threshold.application.selection.page.component';
import { ThresholdServerSelectionPageComponent } from './threshold.server.selection.page/threshold.server.selection.page.component';
import { ThresholdHistoricalSettingsPageComponent } from './threshold.historical.settings.page/threshold.historical.settings.page.component';

@Component({
  selector: 'kpi-threshold-wizard',
  providers: [ThresholdWizardService],
  templateUrl: '../../wizard.template.html',
  styleUrls: ['../../wizard.component.style.scss', '../../wizard.button.style.scss']
})
export class ThresholdWizardComponent
  extends WizardComponent
  implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
  @ViewChild('contentPlaceholder', { read: ViewContainerRef, static: true })
  contentRef: ViewContainerRef;
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef, static: true })
  subContentRef: ViewContainerRef;
  wizardConfig: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  wizardId: string;
  dataId: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  onClose = new EventEmitter<any>(); //eslint-disable-line @typescript-eslint/no-explicit-any
  widgetConfig: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  state: Router;
  wizardService: BaseWizardService;
  userService: UserService;
  openWizard: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;
  activatedRouteSubscription: Subscription;

  constructor(
    state: Router,
    wizardService: ThresholdWizardService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly launcher: WizardLauncherService,
    private readonly factoryResolver: ComponentFactoryResolver,
    private readonly exchange: ValuesExchangeProvider
  ) {
    super();
    this.state = state;
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  get(object: any, path: string): any {
    return get(object, path);
  }

  ngOnInit() {
    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe(data => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', '{}')));
      this.wizardService.editMode =
        this.wizardId === 'update_threshold' || this.wizardId === 'update_historical_threshold';
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
    });
    this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

  //-------------- Control && Validation -----------------------
  toggleNext(): void {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack(): void {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleClose(): void {
    this.wizardService.toggleClose(() => {
      this.onClose.emit(true);
      this.exchange.notifyListeners('update_threshold', { noValue: true });
    });
  }

  toggleReOpen(): void {
    this.wizardService.reOpen();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  notifyOnToggleSubContent(onOff: any): void {
    if (onOff) {
      this.createSubContentComponent();
    } else {
      this.subContentRef.clear();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  getWizardService(): any {
    return this.wizardService;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  getFactoryResolver(): any {
    return this.factoryResolver;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  getContentViewRef(): any {
    return this.contentRef;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  getSubContentViewRef(): any {
    return this.subContentRef;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  resolveComponentType(pageId: any): any {
    switch (pageId) {
      case 'threshold.site.selection.html':
        return ThresholdSiteSelectionComponent;
      case 'threshold.application.selection.html':
        return ThresholdApplicationSelectionComponent;
      case 'threshold.settings.page.html':
        return ThresholdSettingsComponent;
      case 'threshold.server.selection.html':
        return ThresholdServerSelectionPageComponent;
      case 'threshold.historical.settings.page.html':
        return ThresholdHistoricalSettingsPageComponent;
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
}
